import { isString } from 'fitify-types/src/type-guards/common'
import useDelayUnmount from 'fitify-ui/src/hooks/useDelayUnmount'
import { CrossIcon } from 'fitify-ui/src/Icon/outline/CrossIcon'
import { Portal } from 'fitify-ui/src/Portal/Portal'

import { IconButton } from '../GenderFunnel/Button/IconButton'

import {
  MODAL_ANIMATE_DURATION,
  StyledBottomContent,
  StyledContainer,
  StyledContent,
  StyledHeader,
  StyledHeaderTypography,
  StyledOverlay,
} from './Modal.Styled'
import type { ModalProps } from './Modal.Types'

export const Modal = ({
  backgroundColor = 'base',
  bottomContent,
  children,
  header,
  id,
  isOpen,
  onClose,
  ref,
}: ModalProps) => {
  const shouldRenderModal = useDelayUnmount(isOpen, MODAL_ANIMATE_DURATION)

  if (!shouldRenderModal) {
    return null
  }

  return (
    <Portal id={id}>
      <StyledOverlay $isOpen={isOpen}>
        <StyledContainer
          $backgroundColor={backgroundColor}
          $isOpen={isOpen}
          ref={ref}
        >
          <StyledHeader>
            {isString(header) ? (
              <StyledHeaderTypography
                $variant="Poppins/H3 - Medium"
                dangerouslySetInnerHTML={{ __html: header }}
              />
            ) : (
              header
            )}
            {onClose && (
              <IconButton onClick={onClose} size="large">
                <CrossIcon />
              </IconButton>
            )}
          </StyledHeader>
          <StyledContent>
            {children}
            {bottomContent && (
              <StyledBottomContent>{bottomContent}</StyledBottomContent>
            )}
          </StyledContent>
        </StyledContainer>
      </StyledOverlay>
    </Portal>
  )
}
